// ./differentials/card.tsx
"use client";
import { motion } from "framer-motion";
import Badge from "../ui/badge";
import { Sparkles, Zap, Heart, Shield, Leaf, Star, BookOpen, Cpu } from "lucide-react";
import React from "react";

interface IDifferentialCard {
  icon: string;
  title: string;
  description: string | string[];
  index: number;
}

const iconsMap = {
  Sparkles,
  Zap,
  Heart,
  Shield,
  Leaf,
  Star,
  BookOpen,
  Cpu,
};

export default function DifferentialCard({
  icon,
  title,
  description,
  index,
}: IDifferentialCard) {
  const Icon = iconsMap[icon as keyof typeof iconsMap];

  return (
    <motion.div
      initial={{ opacity: 0, y: 0 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className={`relative z-10 flex flex-col items-start gap-y-4 p-4 
        group rounded-2xl backdrop-blur-md hover:shadow-sm hover:scale-101 border border-gray-200 
        hover:border-accent/50 transition-all duration-500`}
    >
      <div className="h-8 w-8 inline-flex items-center justify-center rounded-full shadow-md">
        <Icon />
      </div>

      <Badge>{title}</Badge>

      {Array.isArray(description) ? (
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          {description.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      ) : (
        <p className="text-primary-foreground/90 leading-relaxed">
          {description}
        </p>
      )}
    </motion.div>
  );
}
